import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contentId", "contentType", "portalId", "render"],
  _excluded2 = ["contentId", "contentType", "render"],
  _excluded3 = ["contentId", "contentType", "portalId", "renderAssignments", "renderPortals"];
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useContentAssignmentsPortals, useContentAssignmentsForPortal } from '../contentAssignmentsQueries';
import { LazyLoadScrollContainer } from '../../lazyLoad/components/LazyLoadScrollContainer';
import CardSearchInput from '../../cardMenu/components/CardSearchInput';
import { TABLE_SIZE } from '../../table/tableTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentAssignmentsSearchContext = /*#__PURE__*/createContext({
  selectedPortalId: null,
  selectPortal: () => {},
  unselectPortal: () => {}
});
export const useContentAssignmentsSearchContext = () => useContext(ContentAssignmentsSearchContext);
export const ContentAssignmentsSearchProvider = ({
  children
}) => {
  const [selectedPortalId, setSelectedPortalId] = useState(null);
  const selectPortal = useCallback(portalId => setSelectedPortalId(portalId), []);
  const unselectPortal = useCallback(() => setSelectedPortalId(null), []);
  const contextState = useMemo(() => ({
    selectedPortalId,
    selectPortal,
    unselectPortal
  }), [selectPortal, selectedPortalId, unselectPortal]);
  return /*#__PURE__*/_jsx(ContentAssignmentsSearchContext.Provider, {
    value: contextState,
    children: children
  });
};
const ContentAssignmentsForPortalSearch = _ref => {
  let {
      contentId,
      contentType,
      portalId,
      render
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [query, setQuery] = useState();
  const [page, setPage] = useState(1);
  const {
    contentAssignmentsForPortal,
    contentAssignmentsForPortalLoading,
    total
  } = useContentAssignmentsForPortal({
    contentId,
    contentType,
    portalId,
    offset: (page - 1) * TABLE_SIZE,
    query
  });
  const handleSearchChange = useCallback(searchQuery => {
    setQuery(searchQuery);
    setPage(1);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CardSearchInput, {
      onSearchChange: handleSearchChange,
      placeholder: "academyComponents.topFilters.searchUser.placeholder"
    }), /*#__PURE__*/_jsx(LazyLoadScrollContainer, Object.assign({
      data: contentAssignmentsForPortal,
      loadNextPage: () => setPage(page + 1),
      loading: contentAssignmentsForPortalLoading,
      page: page,
      render: render,
      state: query,
      total: total || 0
    }, props))]
  });
};
const ContentAssignmentsPortalsSearch = _ref2 => {
  let {
      contentId,
      contentType,
      render
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const [query, setQuery] = useState();
  const [page, setPage] = useState(1);
  const {
    contentAssignmentsPortals,
    total,
    contentAssignmentsPortalsLoading
  } = useContentAssignmentsPortals({
    contentId,
    contentType,
    offset: (page - 1) * TABLE_SIZE,
    query
  });
  const handleSearchChange = useCallback(searchQuery => {
    setQuery(searchQuery);
    setPage(1);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CardSearchInput, {
      onSearchChange: handleSearchChange,
      placeholder: "academyComponents.topFilters.searchAccounts.placeholder"
    }), /*#__PURE__*/_jsx(LazyLoadScrollContainer, Object.assign({
      data: contentAssignmentsPortals,
      loadNextPage: () => setPage(page + 1),
      loading: contentAssignmentsPortalsLoading,
      page: page,
      render: render,
      state: query,
      total: total || 0
    }, props))]
  });
};
export const ContentAssignmentsSearch = _ref3 => {
  let {
      contentId,
      contentType,
      portalId: propPortalId,
      renderAssignments,
      renderPortals
    } = _ref3,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  const {
    selectedPortalId: contextPortalId
  } = useContext(ContentAssignmentsSearchContext);
  const {
    contentAssignmentsPortals,
    total
  } = useContentAssignmentsPortals({
    contentId,
    contentType,
    skip: !!(contextPortalId || propPortalId)
  });
  const uniquePortalId = total === 1 && contentAssignmentsPortals !== null && contentAssignmentsPortals !== void 0 && contentAssignmentsPortals.length ? contentAssignmentsPortals[0].portal.id : undefined;
  const selectedPortalId = contextPortalId || propPortalId || uniquePortalId;
  return selectedPortalId ? /*#__PURE__*/_jsx(ContentAssignmentsForPortalSearch, Object.assign({
    contentId: contentId,
    contentType: contentType,
    portalId: selectedPortalId,
    render: renderAssignments
  }, props)) : /*#__PURE__*/_jsx(ContentAssignmentsPortalsSearch, Object.assign({
    contentId: contentId,
    contentType: contentType,
    render: renderPortals
  }, props));
};
export default ContentAssignmentsSearch;